module.exports = __webpack_public_path__ + "on-site-messaging-cover.275dc1879b29af2f4093990f98d16045.png";